import classNames from "classnames";
import styles from "./style.module.scss";

interface CustomToolTipProps {
  children: any;
  label: string;
  customTooltipTextStyle?: string;
}

const CustomToolTip = ({
  children,
  label,
  customTooltipTextStyle,
}: CustomToolTipProps) => {
  return (
    <div className={classNames(styles.tooltip)}>
      {children}
      <span
        className={classNames(styles.tooltiptext, customTooltipTextStyle)}
      >
        {label}
      </span>
    </div>
  );
};

export default CustomToolTip;
